import Vue from 'vue'
import Router from 'vue-router'
import ItemShop from './views/ItemShop.vue'
import GiftItemShop from './views/GiftItemShop.vue'
import GiftItemShop_pre from './views/GiftItemShop_NotYet'
import MyRoom from './views/MyRoom.vue'
import Box from './views/Box.vue'
import GiftBox from './views/GiftBox.vue'
import Login from './views/Login.vue'
import v404 from './views/404.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/shop/:type/:page',
      name: 'ItemShop',
      component: ItemShop
    },
    {
      path: '/giftshop/:type/:page',
      name: 'GiftItemShop',
      component: GiftItemShop,
      beforeEnter: function(to, from, next) {
        // 인증 값 검증 로직 추가
        if(+new Date() < 1652403600000){
          next('/gift_pre')
        } else {
          next()
        }
      }
    },
    {
      path: '/giftshop_b/:type/:page',
      name: 'GiftItemShopB',
      component: GiftItemShop
    },
    {
      path: '/gift_pre',
      name: 'GiftPreOpen',
      component: GiftItemShop_pre
    },
    {
      path: '/my_room/inventory/:page',
      name: 'My Room Inventory',
      component: MyRoom
    },
    {
      path: '/my_room/gift/incoming/:page',
      name: 'GiftBox Incoming',
      component: GiftBox,
      props: {direction: 'incoming'}
    },
    {
      path: '/my_room/gift/outgoing/:page',
      name: 'GiftBox Outgoing',
      component: GiftBox,
      props: {direction: 'outgoing'}
    },
    {
      path: '/box',
      name: 'Box',
      component: Box
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '*',
      name: '404',
      component: v404
    },
  ]
})
